module.exports = __webpack_public_path__ + "static/index/img/edit_banner_background.df4c4f8c.png";